<script lang="ts">
  import { prepareSalesDivisions } from "@retailer/services/product_card_service";

  import type { ProductLine, SalesDivision } from "@shared/types/ProductLine";

  export let alignHorizontally: boolean = false;
  export let productLine: ProductLine;
  export let stateParams: any = {};
  export let skuItemSalesDivisions: SalesDivision[] = null; // For use sku items only

  const salesDivisions = skuItemSalesDivisions || prepareSalesDivisions(productLine);

  const tooltipText = salesDivisions.length == 1 ? "Sales Division" : "Sales Divisions";
</script>

<style>
  .fizz-tooltip-container {
    width: auto;
  }
  .fizz-tooltip-trigger {
    font-weight: normal;
    white-space: break-spaces;
  }
</style>

{#if salesDivisions.length}
  {#if alignHorizontally && !stateParams.distributors?.length}
    <span data-testid="product-card-sales-divisions-horizontal-spacer">-</span>
  {/if}
  <div data-testid="product-card-sales-divisions">
    <div class="fizz-tooltip-container" data-testid="product-card-sales-divisions-tooltip">
      <button class="fizz-tooltip-trigger" aria-describedby="tooltip-desc2">
        <span class="fizz-text-medium fizz-text-subdued fizz-underline-dashed">
          {tooltipText}
        </span>
      </button>
      <div
        class="fizz-tooltip fizz-tooltip-top"
        role="tooltip"
        id="tooltip-desc2"
        data-testid="sales-division-tooltip-container"
      >
        {#each salesDivisions as salesDivision}
          <div data-testid={`product-card-sales-division-${salesDivision.id}`}>
            {salesDivision.name}
          </div>
        {/each}
      </div>
    </div>
  </div>
{/if}
